import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles({
  miniSpan: {
    fontSize: 16,
    color: '#979797',
  },
})
